import service from '@/utils/request'

export function deptList(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/listTree',
		data: param
	})
}

export function deptListAll() {
	return service.request({
		method: 'post',
		url: '/app/dept/list',
	})
}

export function deptTreeSelect(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/deptTreeSelect',
		data: param
	})
}

export function addDept(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/add',
		data: param
	})
}

export function editDept(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/edit',
		data: param
	})
}
export function delDept(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/del',
		data: param
	})
}

export function exportDept(param) {
	return service.request({
		method: 'post',
		url: '/app/dept/export',
		data: param
	})
}


export function queryAllDeptList(param) {	// purchaseOrg:采购组织  stockOrg:库存组织  purchaseDept:采购部门
	return service.request({
		method: 'post',
		url: '/app/dept/queryAllDeptList',
		data: param
	})
}
